import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { attach } from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import selectors from '../selectors';
import BaseLayout from './BaseLayout';
import Loading from './Loading';
import OrderForm from '../components/OrderForm';

class Order extends Component {
    static mapState = (state) =>
        mapSelectors(state, {
            isLoggedIn: selectors.login.getIsLoggedIn,
            wantLogin: selectors.login.getWantLogin,
        });

    render() {
        if(process.env.DOWNTIME == 'True'){
            return <Redirect to="/maintenance" />;
        } 
        if (this.props.wantLogin) {
            return <Redirect to="/login" />;
        }
        if (!this.props.isLoggedIn) {
            return <Loading />;
        }
        return (
            <BaseLayout>
                <OrderForm />
            </BaseLayout>
        );
    }
}

export default attach(Order);



// WEBPACK FOOTER //
// ./app/views/Order.jsx